import { render, staticRenderFns } from "./CreateNewPass.vue?vue&type=template&id=01cdbda8&scoped=true&"
import script from "./CreateNewPass.vue?vue&type=script&lang=js&"
export * from "./CreateNewPass.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewPass.vue?vue&type=style&index=0&id=01cdbda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cdbda8",
  null
  
)

export default component.exports